/*
 * @Author: lidan
 * @Date: 2021-04-15 10:33:45
 * @LastEditTime: 2021-04-21 13:44:19
 * @LastEditors: lidan
 * @Description: 门店位置校准 api
 * @FilePath: \e6-module-base-data\src\e6-module-base-data\api\storeLocationCalibration.js
 */
import http from "e6-base-core/axios/config";
import { e6ModuleBaseDataApi } from "@/config/api";
const { host, E6_MS_TMS_E6YUN_BASE_WEB } = e6ModuleBaseDataApi;

//获取门店位置校准列表
export function queryListStoreLocation(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/storeLocation/queryList`,
    method: "post",
    data
  });
}
// 导出门店位置校准列表
export function exportStoreLocation(data) {
  return http({
    responseType: "blob",
    headers: { "Content-Type": "application/json" },
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/storeLocation/export`,
    method: "post",
    data
  });
}

//门店位置审核通过
export function checkPass(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/storeLocation/checkPass`,
    method: "post",
    data
  });
}

//门店位置审核不通过
export function notPass(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/storeLocation/notPass`,
    method: "post",
    data
  });
}
